import React from "react";

export default function DisableOverlay({
  children,
  merchantName,
  isCheckoutEnabled,
}: {
  children: React.ReactNode;
  merchantName: any;
  isCheckoutEnabled: any;
}) {
  if (isCheckoutEnabled) return <>{children}</>;

  return (
    <div>
      <div className={`cursor-not-allowed flex flex-col inset-0`}>
        {children}
      </div>
      <div className="fixed cursor-not-allowed sm:absolute bottom-0 left-0 w-full max-w-full h-[64px] max-h-[64px] overflow-hidden pl-6 pt-2 pb-2 pr-6 opacity-100 bg-[#E6F3FF] text-[#373737] text-[15px] line-clamp-2 font-medium justify-center text-center ">
        {merchantName} isn&#39;t accepting online orders right now.{" "}
      </div>
    </div>
  );
}
